import { TAG_COLORS } from "@/ts/constants";
import { titleCase } from "@/ts/utils";
import { ICellRendererParams } from "ag-grid-community";
import { FaRegEdit } from "react-icons/fa";
import React, { useState } from "react";
import { VcpmColumns, GlobalTagRecordType } from "@/ts/common-types";

const VcpmGlobalTagCellRenderer = (params: ICellRendererParams) => {
    const value = params.value;
    let colorIdx = 0;
    if (params.colDef.field === VcpmColumns.SUBCATEGORY.toLowerCase())
        colorIdx = 1;
    if (params.colDef.field === VcpmColumns.BRAND.toLowerCase()) colorIdx = 2;
    const { fill, border } = TAG_COLORS[colorIdx];
    const [tagHover, setTagHover] = useState(false);

    const commonTagStyle = {
        borderRadius: 8,
        width: 170,
        minWidth: 170,
        maxWidth: 170,
        height: 32,
        lineHeight: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 10px 0 14px",
        letterSpacing: 0.15,
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        transition: "box-shadow 0.2s, border 0.2s, background 0.2s, color 0.2s",
        cursor: "pointer",
    };

    return (
        <span
            className="mt-2"
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <span
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    minHeight: 32,
                    height: 32,
                }}
            >
                {value ? (
                    <span
                        style={{
                            ...commonTagStyle,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontWeight: 500,
                            fontSize: 15,
                            color: fill,
                            verticalAlign: "middle",
                            background: tagHover
                                ? "rgba(255,255,255,0.5)"
                                : "rgba(255,255,255,0.35)",
                            boxShadow: tagHover
                                ? "0 2px 8px 0 rgba(31, 38, 135, 0.12)"
                                : "0 4px 24px 0 rgba(31, 38, 135, 0.08)",
                            border: `1.5px solid ${border}`,
                        }}
                        title={value}
                        onMouseOver={() => setTagHover(true)}
                        onMouseOut={() => setTagHover(false)}
                        onClick={() => {
                            if (params.colDef && params.api && params.node) {
                                params.api.startEditingCell({
                                    rowIndex: params.node.rowIndex,
                                    colKey: params.colDef.field,
                                });
                            }
                        }}
                    >
                        <span
                            style={{
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                textAlign: "center",
                                flex: 1,
                            }}
                        >
                            {titleCase(value)}
                        </span>
                        <span
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: 8,
                                padding: 3,
                                borderRadius: 8,
                                height: 26,
                                width: 26,
                                boxSizing: "border-box",
                                background: "transparent",
                                transition: "background 0.2s, box-shadow 0.2s",
                            }}
                        >
                            <FaRegEdit
                                style={{
                                    color: tagHover ? fill : border,
                                    fontSize: 15,
                                    verticalAlign: "middle",
                                    transition: "color 0.2s",
                                }}
                            />
                        </span>
                    </span>
                ) : (
                    <span
                        style={{
                                ...commonTagStyle,
                            fontStyle: "italic",
                            fontWeight: 400,
                            fontSize: 14,
                                color: tagHover ? fill : "#bbb",
                                background: tagHover
                                    ? "rgba(255,255,255,0.5)"
                                    : "rgba(255,255,255,0.25)",
                                boxShadow: tagHover
                                    ? "0 2px 8px 0 rgba(31, 38, 135, 0.12)"
                                    : "0 4px 24px 0 rgba(31, 38, 135, 0.08)",
                                border: `1.5px solid #e0e0e0`,
                            }}
                            onMouseOver={() => setTagHover(true)}
                            onMouseOut={() => setTagHover(false)}
                            onClick={() => {
                                if (params.colDef && params.api && params.node) {
                                    params.api.startEditingCell({
                                        rowIndex: params.node.rowIndex,
                                        colKey: params.colDef.field,
                                    });
                                }
                            }}
                        >
                            <span
                                style={{
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    textAlign: "center",
                                    flex: 1,
                                }}
                            >
                                — Select —
                            </span>
                            <span
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginLeft: 8,
                                    padding: 3,
                                    borderRadius: 8,
                                    height: 26,
                                    width: 26,
                                    boxSizing: "border-box",
                                    background: "transparent",
                                    transition: "background 0.2s, box-shadow 0.2s",
                                }}
                            >
                                <FaRegEdit
                                    style={{
                                        color: tagHover ? fill : "#bbb",
                                        fontSize: 15,
                                        verticalAlign: "middle",
                                        transition: "color 0.2s",
                                    }}
                                />
                            </span>
                    </span>
                )}
            </span>
        </span>
    );
};

export default VcpmGlobalTagCellRenderer;
